import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import {
    IReviewsProductTypeID,
    isoReviewsBrandID,
    isoReviewsProductTypeID,
} from "../../../models/nominals";
import { ReviewSortOption } from "../../../models/reviews";
import { useSSRStorePrefill } from "../../../store/reducers";
import { ReviewsViewer } from "../ReviewsViewer";
import { prefillSSRReviewsPageData } from "../ssr";

type IProps = Immutable<
    templates.ReviewsPageTemplate & {
        // Site-specific overrides (not in Django template context)
        sourceFilterWhitelist?: readonly string[];
        starHasStroke?: boolean;
        isCondensedView?: boolean;
        pageSize?: number;
        enablePDPLinks?: boolean;
    }
>;

export const ReviewsViewerSSR = (props: IProps): React.JSX.Element => {
    useSSRStorePrefill(
        {
            products_data: props.products_data,
            reviews_data: props.reviews_data,
            facets_data: props.facets_data,
            brand_id: props.brand_id,
            default_sort: props.default_sort,
            product_type_whitelist_ids: props.product_type_whitelist_ids,
        },
        prefillSSRReviewsPageData,
    );

    const brandID = isoReviewsBrandID.wrap(props.brand_id);

    const displayedProductTypeIDWhitelist: readonly IReviewsProductTypeID[] =
        React.useMemo(() => {
            try {
                const ids = JSON.parse(
                    props.product_type_whitelist_ids,
                ) as number[];
                return ids.map((id) => isoReviewsProductTypeID.wrap(id));
            } catch (e) {
                console.error(
                    "Failed to parse SSR product_type_whitelist_ids:",
                    e,
                );
                return [];
            }
        }, [props.product_type_whitelist_ids]);

    return (
        <ReviewsViewer
            brandID={brandID}
            defaultSortOption={props.default_sort as ReviewSortOption}
            pageSize={props.pageSize}
            displayedProductTypeIDWhitelist={displayedProductTypeIDWhitelist}
            sourceFilterWhitelist={props.sourceFilterWhitelist}
            starHasStroke={props.starHasStroke}
            showSources={props.show_sources}
            enablePDPLinks={props.enablePDPLinks}
            writeReviewURL={props.write_review_url}
            showAppliedFilters={props.show_applied_filters}
            isCondensedView={props.isCondensedView}
        />
    );
};
